import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Address } from '../models/address.model';
import { GeocodeAddressSchema } from '../schemas/geocode-address.schema';
import { GraphqlService } from './graphql.service';

@Injectable({
	providedIn: 'root'
})
export class GeocodeService extends GraphqlService {
	/**
	 * Get latitude and logitude for an address
	 */
	geocodeAddress(address: Address): Observable<Address> {
		return this.query(GeocodeAddressSchema.getGeocodeAddress, {
			address: address.getDataForApi()
		}).pipe(map((data: any) => Address.map(data.geocodeAddress)));
	}
}
